import {cardText} from './ticketDisplay'
export default function MessageBody({body,detailed=false}:{body:string;detailed?:boolean}){
 const original=body
 if(detailed)body=cardText(body)
 const [first,...rest]=body.split('\n');const summary=first.trim(),more=rest.join('\n').trim()
 const technical=detailed&&original!==body?<details><summary>פרטים טכניים מקוריים</summary><p className="cc-message-text">{original}</p></details>:null
 if(!detailed||body.length<650||!summary||!more)return <><p className="cc-message-text">{body}</p>{technical}</>
 return <><p className="cc-message-text">{summary}</p><details className="cc-message-details"><summary>פירוט התשובה והבדיקות</summary><p className="cc-message-text">{more}</p></details>{technical}</>
}
